import { useMemo } from 'react'
import { useDataFormat } from 'Simple/Data.js'
import { REPORT_TYPES } from 'DesignSystem/Report/helpers.js'

function useTablePresetKey(props) {
  return useDataFormat({
    context: 'report',
    path: 'type',
    viewPath: props.viewPath,
    format: report_type => `report-preset-${report_type}`,
  })
}

export function useTablePreset(props) {
  let key = useTablePresetKey(props)

  return useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch {
      return null
    }
  }, []) // eslint-disable-line
}

export function useOnChangeTablePreset(props) {
  let key = useTablePresetKey(props)

  return async function onChangeTablePreset(data) {
    localStorage.setItem(key, JSON.stringify(data))
  }
}

export function buildFilterModel(accounts_receivable_filters, report_type) {
  if (report_type !== REPORT_TYPES.ACCOUNTS_RECEIVABLE) {
    return {} // No custom filters for other reports
  }

  return {
    ACCOUNT_TYPE: {
      filterType: 'set',
      values: accounts_receivable_filters.account_types,
    },
  }
}

export function buildExternalFilterConfig(
  accounts_receivable_filters,
  report_type
) {
  if (report_type !== REPORT_TYPES.ACCOUNTS_RECEIVABLE) {
    return {
      enabled: false,
      selectedBuckets: [],
      include_future_due: false,
      include_credits: false,
    }
  }

  // External filter handles buckets, future due, and credits with OR logic
  // Account Type uses standard AG Grid filter
  return {
    enabled: true,
    selectedBuckets: accounts_receivable_filters.due_buckets,
    include_future_due: accounts_receivable_filters.include_future_due,
    include_credits: accounts_receivable_filters.include_credits,
  }
}
